interface ControlData {
  prevalence?: number;
  [key: string]: any;
}

interface StatusData {
  Status: string;
}

const updateFunc = (controlData: ControlData): StatusData[] => {
  const prevalence =
    controlData["prevalence"] !== undefined ? controlData["prevalence"] : 10;
  const h = 1000 - prevalence;
  const d = prevalence;

  const jsonHealthy: StatusData = { Status: "Healthy" };
  const jsonDiseased: StatusData = { Status: "Diseased" };
  const repeatedHealthy = Array(h).fill(jsonHealthy);
  const repeatedDiseased = Array(d).fill(jsonDiseased);
  const calculatedData = repeatedHealthy.concat(repeatedDiseased);

  return calculatedData;
};

export default updateFunc;
